// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/price_range.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_money } from "../../core/money_pb";

/**
 * Describes the file proto/model/feature/hotel/price_range.proto.
 */
export const file_proto_model_feature_hotel_price_range = /*@__PURE__*/
  fileDesc("Citwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL3ByaWNlX3JhbmdlLnByb3RvEgZjYXJtZW4iaQoKUHJpY2VSYW5nZRIgCgltaW5fcHJpY2UYASABKAsyDS5jYXJtZW4uTW9uZXkSIAoJbWF4X3ByaWNlGAIgASgLMg0uY2FybWVuLk1vbmV5EhcKD3ByaWNlX3F1YWxpZmllchgDIAEoCUI2WjRnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsYgZwcm90bzM", [file_proto_model_core_money]);

/**
 * Describes the message carmen.PriceRange.
 * Use `create(PriceRangeSchema)` to create a new message.
 */
export const PriceRangeSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_price_range, 0);

